<template>
    <div class="component-wrap">

        <AppContentHeader headline="Reports" />

        <div class="md-layout md-gutter">

            <div 
                class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 card-container" 
                @click="$router.push('/reports/billing')"
            >
                <div class="report-box md-elevation-15">
                    <div class="report-box__info">
                        <h3 class="md-subheading"><strong>Billing Reports</strong></h3>
                        <h6 class="md-subheading">Reports for generating invoices and billing.</h6>
                        <md-button class="md-raised md-primary">VIEW REPORTS</md-button>
                    </div>
                    <md-tooltip md-direction="top">View reports</md-tooltip>
                </div>
            </div>

            <div 
                class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 card-container"
                @click="$router.push('/reports/action-log')"
            >
                <div class="report-box md-elevation-15">
                    <div class="report-box__info">
                        <h3 class="md-subheading"><strong>Action Log</strong></h3>
                        <h6 class="md-subheading">Generate Excel spreadsheet with timestamps for status changes.</h6>
                        <md-button class="md-raised md-primary">RUN REPORT</md-button>
                    </div>
                    <md-tooltip md-direction="top">Run report</md-tooltip>
                </div>
            </div>

            <div 
                class="md-layout-item md-size-33 md-medium-size-100 md-small-size-100 card-container"
                @click="$router.push('/reports/end-of-market-disposition')"
            >
                <div class="report-box md-elevation-15">
                    <div class="report-box__info">
                        <h3 class="md-subheading"><strong>End of Market Disposition</strong></h3>
                        <h6 class="md-subheading">Report for post-market disposition.</h6>
                        <md-button class="md-raised md-primary">RUN REPORT</md-button>
                    </div>
                    <md-tooltip md-direction="top">Run report</md-tooltip>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'ReportsDashboard',
        data() {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    .component-wrap {
        padding: 16px;
    }

    .card-container {
        /* Adds space between cards when they wrap into a column */
        margin-bottom: 24px; 
    }

    .report-box {
        display: flex;
        flex-direction: column;
        padding: 2.4rem;
        cursor: pointer;
        height: 100%; 
        background: #fff;
        /* Hover effect removed */

        &__info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            text-align: center;

            .md-button {
                margin-top: 2rem;
                align-self: center;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
                border-radius: 4px;
                min-width: 150px;
            }
        }

        h3 {
            margin-top: 0;
            margin-bottom: 1rem;
        }

        h6.md-subheading {
            font-size: 14px;
            line-height: 1.4;
            color: rgba(0,0,0,0.7);
            flex-grow: 1; 
        }
    }
</style>